module.exports = __webpack_public_path__ + "static/img/bg.bcf0acd3.png";